import { registerQuery, useSuspenseQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
const getAppObjectsFromNames = names => {
  return http.get('inbounddb-meta/v1/object-types/batch-get-by-names', {
    query: {
      name: names
    }
  });
};
const GET_APP_OBJECT_NAMES = registerQuery({
  fieldName: 'appObjectNames',
  args: ['names'],
  fetcher: async ({
    names
  }) => {
    if (names.length === 0) {
      return {};
    }
    try {
      const data = await getAppObjectsFromNames(names);
      const objectMap = new Map(data.map(object => [object.fullyQualifiedName, object]));
      return Object.fromEntries(names.map(name => {
        const appObject = objectMap.get(name);
        return [name, (appObject === null || appObject === void 0 ? void 0 : appObject.singularForm) || (appObject === null || appObject === void 0 ? void 0 : appObject.pluralForm) || (appObject === null || appObject === void 0 ? void 0 : appObject.name)];
      }));
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          query: 'appObjectNames'
        }
      });
      // on error, return empty object -- we'll just show the internal names
      return {};
    }
  }
});
export const useFetchAppObjectNames = ({
  names
}) => {
  return useSuspenseQuery(GET_APP_OBJECT_NAMES, {
    variables: {
      names
    }
  }).data.appObjectNames;
};